<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('allocationOrder.queryCondition') }}</div>
        <div class="ibox-tools" style="top:10px;">
        </div>
      </div>
      <div class="">
        <el-form :inline="true" :model="allocationOrderManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-form-item>
              <el-input v-model="allocationOrderManageInfo.conditions.orderId"
                :placeholder="$t('allocationOrder.inputOrderId')" clearable />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-select v-model="allocationOrderManageInfo.conditions.srcShId"
                :placeholder="$t('allocationOrder.selectSrcWarehouse')" style="width:100%" clearable>
                <el-option v-for="(item, index) in allocationOrderManageInfo.shopHouses" :key="index"
                  :label="item.shName" :value="item.shId" />
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-select v-model="allocationOrderManageInfo.conditions.targetShId"
                :placeholder="$t('allocationOrder.selectTargetWarehouse')" style="width:100%" clearable>
                <el-option v-for="(item, index) in allocationOrderManageInfo.shopHouses" :key="index"
                  :label="item.shName" :value="item.shId" />
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-select v-model="allocationOrderManageInfo.conditions.state"
              :placeholder="$t('allocationOrder.selectStatus')" style="width:100%" clearable>
              <el-option v-for="item in allocationOrderManageInfo.states" :key="item.value" :label="item.label"
                :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" size="small" @click="_queryAssetInventoryMethod()">
                <i class="el-icon-search"></i> {{ $t('common.query') }}
              </el-button>
              <el-button type="primary" size="small" @click="_resetAssetInventoryMethod()">
                <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
              </el-button>
          </el-form-item>


          
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('allocationOrder.assetAllocation') }}</div>
        <div class="ibox-tools" style="top:10px;">
          <el-button type="primary" size="small" @click="_openAddAssetInventoryModal()">
            <i class="el-icon-plus"></i> {{ $t('allocationOrder.allocation') }}
          </el-button>
        </div>
      </div>
      <div class="">
        <el-table :data="allocationOrderManageInfo.allocationOrders" border style="width: 100%">
          <el-table-column prop="orderId" :label="$t('allocationOrder.orderId')" align="center" />
          <el-table-column prop="prodName" :label="$t('allocationOrder.productName')" align="center" />
          <el-table-column prop="specName" :label="$t('allocationOrder.specName')" align="center" />
          <el-table-column prop="shopName" :label="$t('allocationOrder.srcShop')" align="center" />
          <el-table-column prop="srcShName" :label="$t('allocationOrder.srcWarehouse')" align="center" />
          <el-table-column prop="targetShopName" :label="$t('allocationOrder.targetShop')" align="center" />
          <el-table-column prop="targetShName" :label="$t('allocationOrder.targetWarehouse')" align="center" />
          <el-table-column prop="productCount" :label="$t('allocationOrder.productCount')" align="center" />
          <el-table-column prop="staffName" :label="$t('allocationOrder.allocationPerson')" align="center" />
          <el-table-column prop="stateName" :label="$t('allocationOrder.status')" align="center" />
          <el-table-column prop="createTime" :label="$t('allocationOrder.allocationTime')" align="center" />
          <el-table-column :label="$t('common.operation')" align="center" width="200">
            <template slot-scope="scope">
              <el-button v-if="scope.row.state === '1001'" type="text" size="small"
                @click="_openInStockAssetInventoryModel(scope.row)">
                {{ $t('allocationOrder.audit') }}
              </el-button>
              <el-button v-if="scope.row.state === '1001'" type="text" size="small"
                @click="_openEditAssetInventoryModel(scope.row)">
                {{ $t('common.edit') }}
              </el-button>
              <el-button v-if="scope.row.state === '1001'" type="text" size="small"
                @click="_openDeleteAssetInventoryModel(scope.row)">
                {{ $t('common.delete') }}
              </el-button>
              <el-button v-if="scope.row.state === '2002'" type="text" size="small"
                @click="_doAllocationOrderInModel(scope.row)">
                {{ $t('allocationOrder.inStock') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination :current-page="allocationOrderManageInfo.conditions.page" :page-sizes="[10, 20, 30, 50]"
          :page-size="allocationOrderManageInfo.conditions.row" layout="total, sizes, prev, pager, next, jumper"
          :total="allocationOrderManageInfo.total" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" />
      </div>
    </el-card>

    <delete-asset-inventory ref="deleteAssetInventory" />
    <allocation-order-edit ref="allocationOrderEdit" />
    <delete-allocation-order ref="deleteAllocationOrder" />
    <allocation-order-audit ref="allocationOrderAudit" :call-back-listener="'allocationOrderManage'"
      :call-back-function="'notifyAuditInfo'" />
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import { queryAllocationOrder, listShopHouses, auditAllocationOrder } from '@/api/goods/allocationOrderApi'
import DeleteAssetInventory from '@/components/goods/deleteAssetInventory/deleteAssetInventory.vue'
import AllocationOrderEdit from '@/components/goods/allocationOrderEdit/allocationOrderEdit.vue'
import DeleteAllocationOrder from '@/components/goods/deleteAllocationOrder/deleteAllocationOrder.vue'
import AllocationOrderAudit from '@/components/common/allocationOrderAudit/allocationOrderAudit.vue'

export default {
  name: 'AllocationOrderManage',
  components: {
    DeleteAssetInventory,
    AllocationOrderEdit,
    DeleteAllocationOrder,
    AllocationOrderAudit
  },
  data() {
    return {
      allocationOrderManageInfo: {
        allocationOrders: [],
        shopHouses: [],
        total: 0,
        records: 1,
        moreCondition: false,
        aiId: '',
        curOrder: {},
        states: [],
        conditions: {
          shId: '',
          orderId: '',
          srcShId: '',
          targetShId: '',
          staffName: '',
          state: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._initMethod()
  },
  methods: {
    _initMethod() {
      this._listShopHouses()
      this._listAssetInventorys(1, 10)
      this.getDictData()
    },
    async getDictData() {
      try {
        const {data} = await getDict('allocation_order', 'state')
        this.allocationOrderManageInfo.states = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    handleSizeChange(val) {
      this.allocationOrderManageInfo.conditions.row = val
      this._listAssetInventorys(this.allocationOrderManageInfo.conditions.page, val)
    },
    handleCurrentChange(val) {
      this._listAssetInventorys(val, this.allocationOrderManageInfo.conditions.row)
    },
    async _listAssetInventorys(page, rows) {
      this.allocationOrderManageInfo.conditions.page = page
      this.allocationOrderManageInfo.conditions.row = rows
      this.allocationOrderManageInfo.conditions.shopId = getShopId()

      try {
        const res = await queryAllocationOrder(this.allocationOrderManageInfo.conditions)
        this.allocationOrderManageInfo.total = res.total
        this.allocationOrderManageInfo.records = res.records
        this.allocationOrderManageInfo.allocationOrders = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _openAddAssetInventoryModal() {
      this.$router.push('/pages/goods/allocationOrderIn')
    },
    _openEditAssetInventoryModel(allocationOrder) {
      this.$refs.allocationOrderEdit.open(allocationOrder)
    },
    _doAllocationOrderInModel(inoutOrder) {
      this.$router.push({
        path: '/pages/goods/doAllocationOrderIn',
        query: {
          orderId: inoutOrder.orderId,
          staffName: inoutOrder.staffName,
          stateName: inoutOrder.stateName,
          createTime: inoutOrder.createTime,
          stateRemark: inoutOrder.stateRemark,
          shopName: inoutOrder.shopName,
          srcShName: inoutOrder.srcShName,
          targetShopName: inoutOrder.targetShopName,
          targetShName: inoutOrder.targetShName,
          shopId: inoutOrder.shopId,
          specId: inoutOrder.specId,
          productId: inoutOrder.productId,
          productCount: inoutOrder.productCount,
          state: inoutOrder.state,
          targetShId: inoutOrder.targetShId,
          prodName: inoutOrder.prodName,
          srcShId: inoutOrder.srcShId,
          targetShopId: inoutOrder.targetShopId,
          staffId: inoutOrder.staffId
        }
      })
    },
    _openInStockAssetInventoryModel(order) {
      this.allocationOrderManageInfo.curOrder = order
      this.$refs.allocationOrderAudit.open()
    },
    _openDeleteAssetInventoryModel(allocationOrder) {
      this.$refs.deleteAllocationOrder.open(allocationOrder)
    },
    _queryAssetInventoryMethod() {
      this._listAssetInventorys(1, this.allocationOrderManageInfo.conditions.row)
    },
    _resetAssetInventoryMethod() {
      this.allocationOrderManageInfo.conditions = {
        shId: '',
        orderId: '',
        srcShId: '',
        targetShId: '',
        staffName: '',
        state: '',
        shopId: '',
        page: 1,
        row: 10
      }
      this._listAssetInventorys(1, 10)
    },
    _moreCondition() {
      this.allocationOrderManageInfo.moreCondition = !this.allocationOrderManageInfo.moreCondition
    },
    async _listShopHouses() {
      try {
        const res = await listShopHouses({
          page: 1,
          row: 100,
          shopId: getShopId()
        })
        this.allocationOrderManageInfo.shopHouses = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    async _auditAllocationOrderState(auditInfo) {
      const order = this.allocationOrderManageInfo.curOrder
      order.state = auditInfo.state
      order.stateRemark = auditInfo.remark
      order.flag = '1'

      try {
        await auditAllocationOrder(order)
        this.$message.success(this.$t('allocationOrder.auditSuccess'))
        this._listAssetInventorys(1, this.allocationOrderManageInfo.conditions.row)
      } catch (error) {
        console.error('请求失败:', error)
        this.$message.error(error.message)
      }
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
}

.ibox-title {
  border-color: #edf1f2;
  border-style: solid solid none;
  border-width: 4px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 15px 15px 7px;
  min-height: 48px;
}

.ibox-content {
  clear: both;
  padding: 15px 20px 20px 20px;
}
</style>